import http from "./httpService";
import config from "./../config.json";

let apiEndpoint = process.env.REACT_APP_API_URL || config.apiUrl;
apiEndpoint += "accounts";

export const saveAccountPersonalInfoAsync = async (data) => {
  const account = { ...data };
  account["gender"] = account.gender.value;
  account["citizenship"] = account.citizenship.value;
  account["civil_status"] = account.civil_status.value;

  return await http.put(`${apiEndpoint}/personal/${data.id}`, account);
};

export const saveAccountStatusAsync = async (id, data) => {
  return await http.put(`${apiEndpoint}/statuses/${id}/${data.status.value}`);
};

export const saveAccountSupportAsync = async (id, user_id) => {
  return await http.put(`${apiEndpoint}/support/${id}/${user_id}`);
};

export const saveAccountSupportDesignationAsync = async (id, data) => {
  return await http.put(
    `${apiEndpoint}/support-designations/${id}/${data.designation.value}`
  );
};

export const saveAccountCompletionAsync = async (id) => {
  return await http.put(`${apiEndpoint}/complete/${id}`);
};

export const generateSPAAsync = async (id, data) => {
  return await http.post(`${apiEndpoint}/spa/${id}`, data);
};

export const generateSwornDeclarationDraftAsync = async (data) => {
  return await http.post(`${apiEndpoint}/sworn-declaration`, data);
};

export const generateSwornAsync = async (id, data) => {
  return await http.post(`${apiEndpoint}/sworn-declaration/${id}`, data);
};

export const sendProposalAsync = async (id) => {
  return await http.post(`${apiEndpoint}/proposal/${id}`);
};

export const deleteAccountAsync = async (id) => {
  return await http.delete(`${apiEndpoint}/${id}`);
};

export const saveAccountContactInfoAsync = async (data) => {
  return await http.put(`${apiEndpoint}/contacts/${data.id}`, data);
};

export const saveAccountAddressInfoAsync = async (id, data) => {
  const address = { ...data };
  address["province"] = data.province.label;
  address["city"] = data.city.label;

  return await http.put(`${apiEndpoint}/addresses/${id}`, address);
};

export const saveAccountSpouseInfoAsync = async (id, data) => {
  const spouse = { ...data };
  spouse["employment_status"] = data.employment_status.value;
  spouse["employment_status_type"] = data.employment_status.label;

  return await http.put(`${apiEndpoint}/spouses/${id}`, spouse);
};

export const saveAccountParentsInfoAsync = async (id, data) => {
  const parents = [
    {
      first_name: data.mother_first_name,
      middle_name: data.mother_middle_name,
      last_name: data.mother_last_name,
      parent_type: 1,
    },
    {
      first_name: data.father_first_name,
      middle_name: data.father_middle_name,
      last_name: data.father_last_name,
      parent_type: 2,
    },
  ];

  return await http.put(`${apiEndpoint}/parents/${id}`, parents);
};

export const saveAccountCompliancesInfoAsync = async (data) => {
  return await http.put(`${apiEndpoint}/contributions/${data.id}`, data);
};

export const saveAccountIncomeInfoAsync = async (data) => {
  const income = { ...data };

  const sources = income.sources.map((item) => {
    return item.value;
  }, []);

  const income_source = sources.reduce((a, b) => Number(a) + Number(b), 0);
  income["income_source"] = income_source;

  return await http.put(`${apiEndpoint}/incomes/${data.id}`, income);
};

export const saveAccountIdentityDocumentAsync = async (data) => {
  if (data.id)
    return await http.put(`${apiEndpoint}/identity-documents/${data.id}`, data);

  return await http.post(`${apiEndpoint}/identity-documents`, data);
};

export const saveDateStartedAsync = async (data) => {
  return await http.put(
    `${apiEndpoint}/date-started/${data.id}/${data.started_on}`
  );
};

export const saveCloudStorageURLAsync = async (data) => {
  return await http.put(`${apiEndpoint}/storages/${data.id}`, data);
};

export const saveNotesAsync = async (data) => {
  return await http.put(`${apiEndpoint}/notes`, data);
};

export const saveEmailAsync = async (id, email) => {
  const { data } = await http.post(`${apiEndpoint}/emails/${id}/${email}`);
  return data;
};

export const deleteEmailAsync = async (id) => {
  return await http.delete(`${apiEndpoint}/emails/${id}`);
};

export const deleteIdentityDocumentAsync = async (id) => {
  return await http.delete(`${apiEndpoint}/identity-documents/${id}`);
};

export const getAccountsAsync = async (params) => {
  const {
    sort_column,
    selected_statuses: statuses,
    search_query: query,
    start_date: from,
    end_date: to,
    current_page: page,
    page_size: size,
  } = params;

  const { path: column, order } = sort_column;
  const url = `${apiEndpoint}?q=${query}&statuses=${statuses}&from=${from}&to=${to}&column=${column}&order=${order}&p=${page}&s=${size}`;

  const { data } = await http.get(url);
  return data;
};

export const getAccountRDOsAsync = async (params) => {
  const {
    status,
    rdo,
    sort_column,
    size,
    search_query: query,
    current_page: page,
  } = params;

  const { path: column, order } = sort_column;
  const url = `${apiEndpoint}/revenue-district-offices?q=${query}&status=${status}&rdo=${rdo}&column=${column}&order=${order}&p=${page}&s=${size}`;

  const { data } = await http.get(url);
  return data;
};

export const getAccountClientsAsync = async (id, params) => {
  const { query, page, size } = params;

  const url = `${apiEndpoint}/clients/${id}?q=${query}&p=${page}&s=${size}`;
  const { data } = await http.get(url);
  return data;
};

export const getAccountInfoAsync = async (id) => {
  const { data } = await http.get(`${apiEndpoint}/${id}`);
  return data.result;
};

export const getAccountAddressAsync = async (id) => {
  const { data } = await http.get(`${apiEndpoint}/addresses/${id}`);
  return data.result;
};

export const getAccountSpouseInfoAsync = async (id) => {
  const { data } = await http.get(`${apiEndpoint}/spouses/${id}`);
  return data.result;
};

export const getAccountParentsInfoAsync = async (id) => {
  const { data } = await http.get(`${apiEndpoint}/parents/${id}`);
  return data.result;
};

export const getAccountIdentityDocumentsAsync = async (id) => {
  const { data } = await http.get(`${apiEndpoint}/identity-documents/${id}`);
  return data.result;
};

export const getIdentityDocumentImagesAsync = async (id) => {
  const { data } = await http.get(
    `${apiEndpoint}/identity-documents/images/${id}`
  );
  return data.result;
};

export const getIdentityDocumentTypesAsync = async () => {
  const { data } = await http.get(`${apiEndpoint}/identity-documents/types`);
  return data.result;
};

export const getAccountCitizenshipsAsync = async () => {
  const { data } = await http.get(`${apiEndpoint}/citizenships`);
  return data.result;
};

export const getAppointeesAsync = async () => {
  const { data } = await http.get(`${apiEndpoint}/appointees`);
  return data.result;
};

export const getAccountSecondaryEmailsAsync = async (id) => {
  const { data } = await http.get(`${apiEndpoint}/emails/${id}`);
  return data;
};

export const getAccountGenders = () => {
  return [
    { value: 1, label: "Male" },
    { value: 2, label: "Female" },
  ];
};

export const getAccountIncomeSources = () => {
  return [
    { value: 4, label: "Regular Employee" },
    { value: 2, label: "Contractual Employee" },
    { value: 1, label: "Clinic" },
  ];
};

export const getAccountCivilStatuses = () => {
  return [
    { value: 1, label: "Single" },
    { value: 2, label: "Married" },
    { value: 3, label: "Widowed" },
  ];
};

export const getAccountStatuses = () => {
  return [
    { value: 1, label: "New Entry" },
    { value: 2, label: "Processed" },
    { value: 3, label: "Registration" },
    { value: 4, label: "Active" },
    { value: 5, label: "Archive" },
    { value: 6, label: "Inactive" },
    { value: 7, label: "RDO Transfer" },
    { value: 8, label: "ATP Application" },
    { value: 9, label: "OR Printing" },
    { value: 10, label: "Document Delivery" },
    { value: 11, label: "Open Case Verification" },
    { value: 12, label: "Open Case Resolution" },
  ];
};

export const getAccountSupportDesignations = () => {
  return [
    { value: 0, label: "Unassigned" },
    { value: 1, label: "Medtax" },
    { value: 2, label: "ThinkTank" },
  ];
};

export const getAccountStatusProperties = (status) => {
  let properties = {};

  switch (status) {
    case 1:
      properties = { text_color: "text-gray-400", bg_color: "bg-blue-400" };
      break;
    case 2:
      properties = { text_color: "text-gray-400", bg_color: "bg-purple-300" };
      break;
    case 3:
      properties = { text_color: "text-gray-400", bg_color: "bg-gray-400" };
      break;
    case 4:
      properties = { text_color: "text-gray-400", bg_color: "bg-green-400" };
      break;
    case 5:
      properties = { text_color: "text-gray-400", bg_color: "bg-yellow-200" };
      break;
    case 6:
      properties = { text_color: "text-gray-400", bg_color: "bg-red-300" };
      break;
    default:
      properties = { text_color: "text-gray-400", bg_color: "bg-gray-400" };
  }

  return properties;
};

export const getSupportDesignationProperties = (designation) => {
  let properties = {};

  switch (designation) {
    case 1:
      properties = { text_color: "text-white", bg_color: "bg-blue-400" };
      break;
    case 2:
      properties = { text_color: "text-white", bg_color: "bg-red-400" };
      break;
    default:
      properties = { text_color: "text-gray-400", bg_color: "bg-gray-400" };
  }

  return properties;
};

export const getEmploymentStatuses = () => {
  return [
    { value: 1, label: "Unemployed" },
    { value: 2, label: "Employed Locally" },
    { value: 3, label: "Employed Abroad" },
  ];
};

export const getSPACities = () => {
  return [
    { value: "City of Manila", label: "City of Manila" },
    { value: "Pampanga", label: "Pampanga" },
    { value: "Cebu City", label: "Cebu City" },
  ];
};

const accountService = {
  saveAccountPersonalInfoAsync,
  saveAccountStatusAsync,
  saveAccountSupportAsync,
  saveAccountSupportDesignationAsync,
  saveAccountCompletionAsync,
  generateSPAAsync,
  generateSwornDeclarationDraftAsync,
  generateSwornAsync,
  sendProposalAsync,
  deleteAccountAsync,
  saveAccountContactInfoAsync,
  saveAccountAddressInfoAsync,
  saveAccountSpouseInfoAsync,
  saveAccountParentsInfoAsync,
  saveAccountCompliancesInfoAsync,
  saveAccountIncomeInfoAsync,
  saveAccountIdentityDocumentAsync,
  saveDateStartedAsync,
  saveCloudStorageURLAsync,
  saveNotesAsync,
  saveEmailAsync,
  deleteEmailAsync,
  deleteIdentityDocumentAsync,
  getAccountsAsync,
  getAccountClientsAsync,
  getAccountRDOsAsync,
  getAccountInfoAsync,
  getAccountAddressAsync,
  getAccountSpouseInfoAsync,
  getAccountParentsInfoAsync,
  getAccountIdentityDocumentsAsync,
  getIdentityDocumentImagesAsync,
  getIdentityDocumentTypesAsync,
  getAccountCitizenshipsAsync,
  getAppointeesAsync,
  getAccountSecondaryEmailsAsync,
  getAccountGenders,
  getAccountIncomeSources,
  getAccountCivilStatuses,
  getAccountStatuses,
  getAccountSupportDesignations,
  getAccountStatusProperties,
  getSupportDesignationProperties,
  getEmploymentStatuses,
  getSPACities,
};

export default accountService;
